import { availableTimeZones } from "./time-zones";
import { asDate } from "./as-date";
import type { IsoAndUnixTimestamp } from "./iso-and-unix";
import { toZonedTime } from "date-fns-tz";

/**
 * Get number of day of week with monday as first day of week, 0-6
 * @returns
 */
function getDayOfWeekAsNumber(input: Date, timeZone?: string): number;
function getDayOfWeekAsNumber(
    input: IsoAndUnixTimestamp,
    timeZone?: string,
): number;
function getDayOfWeekAsNumber(
    input: Date | IsoAndUnixTimestamp,
    timeZone = "Europe/Stockholm",
): number {
    if (availableTimeZones) {
        if (!availableTimeZones.has(timeZone)) {
            // Verify the timezone is available for the browser/environment
            // If the environment supports to list the available time zones, else we'll just skip the check
            throw new Error(
                `Timezone ${timeZone} is not available in the environment`,
            );
        }
    }
    // Parse the date string into a Date object in the specified timezone
    const date = input instanceof Date ? input : asDate(input);
    const zonedDate = toZonedTime(date, timeZone);
    // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const dayOfWeek = zonedDate.getDay();

    // Adjust the day index so that Monday is the first day of the week
    // Monday = 0, ..., Sunday = 6
    return (dayOfWeek + 6) % 7;
}

export { getDayOfWeekAsNumber };
